import React from 'react';
import { handleEnterNavigation } from '../../utils/fieldNav';
import './Dropdown.css';

interface DropdownOption {
  value: string | number;
  label: string;
}

interface DropdownProps {
  id: string;
  label: string;
  value: string | number;
  options: DropdownOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

/**
 * Reusable dropdown select component
 */
export function Dropdown({
  id,
  label,
  value,
  options,
  onChange,
  disabled = false,
  className = '',
}: DropdownProps) {
  return (
    <div className={`dropdown-field ${className}`}>
      <label htmlFor={id} className="dropdown-label">
        {label}
      </label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleEnterNavigation}
        disabled={disabled}
        className="dropdown-select"
      >
        {options.map((option) => (
          // Values can repeat across options (e.g. voltages "480/277 V" and
          // "480 V" both carry 480) — the label keeps keys unique.
          <option key={`${option.value}|${option.label}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default Dropdown;
